import { render } from "./HeadingGuest.vue?vue&type=template&id=e677015c"
import script from "./HeadingGuest.vue?vue&type=script&lang=js"
export * from "./HeadingGuest.vue?vue&type=script&lang=js"
script.render = render

export default script